<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Partneret</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="white-background">
              <div class="tabcontent tab-management padding-0 tab-style">
                <table class="table-responsive-lg">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Emri dhe mbiemri / Kompania</th>
                    <th>Email</th>
                    <th>Lloji i Aplikimit</th>
                    <th>Aprovuar?</th>
                    <th>Aprovuar me:</th>
                  </tr>
                  </thead>
                  <tbody>
                  <router-link
                      tag="tr"
                      :to="{ name: 'admin/partner/requests/detail', params: { id: partner.id }}"
                      v-for="partner in partners_list"
                      :key="partner.id"
                  >
                    <th>{{ partner.id }}</th>
                    <th>{{ partner.is_business === 1 ? partner.company_name : partner.first_name + ' ' + partner.last_name }}</th>
                    <th>{{ partner.email }}</th>
                    <th>{{ partner.is_business === 1 ? 'Kompani' : 'Individual' }}</th>
                    <th>{{ partner.approved === 0 ? 'JO' : 'PO' }}</th>
                    <th>{{ partner.approved === 0 ? 'Ne Pritje' : partner.approved_at }}</th>
                  </router-link>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>

<style src="@/assets/admin/css/main.css">
</style>
<script>

import AdminSidebar from "@/components/admin/AdminSidebar.vue";
import { mapGetters } from "vuex";

export default {
  name: "AdminPartnerRequest",
  components: {
    AdminSidebar,
  },
  beforeMount() {
    this.$store.dispatch("partnersForm/getPartnerRequestList");
  },
  computed: {
    ...mapGetters({
      partners_list: "partnersForm/partners_list",
    })
  }
}
</script>

<style scoped>

</style>